import Marionette from 'backbone.marionette';
import memberBillsCompositeviewTmpl from '../templates/member_bills_compositeview.tpl';
import MemberBillsItemview from './member_bills_itemview';
export default Marionette.CompositeView.extend({
  template: memberBillsCompositeviewTmpl,
  childView: MemberBillsItemview,
  tagName: "table",
  className: "table table-hover table-sm",
  childViewContainer: "tbody",
  id: "member-bill-list"

  /*
  onShow: function() {
    $("#member-bill-list").dataTable({
      bSort: false,
      pagingType: 'simple',
      //responsive: true,
      //lengthChange: false,
      //bFilter: false,
      pageLength: 10,
      columnDefs: [
        { className: "bill-name-td", targets:0 } // this keeps the bill number on one line on smallest screens but still allows check mark to wrap
      ]
     // "autoWidth": true,
    });
  }
  */
});